import React from "react";
import Modal from "../UIElements/Modal";
import { Icon } from "../UIElements/Icon";

const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  itemName,
  itemType = "Item",
  title,
  subtitle,
  confirmButtonText,
  isLoading = false,
  detailNote = "This action cannot be undone.",
  confirmLoadingText = "Deleting...",
}) => {
  const defaultTitle = title || `Delete ${itemType}`;
  const defaultSubtitle =
    subtitle ||
    `Are you sure you want to delete this ${itemType.toLowerCase()}?`;
  const defaultConfirmText = confirmButtonText || `Delete ${itemType}`;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={defaultTitle}
      subtitle={defaultSubtitle}
      maxWidth="max-w-md"
    >
      <div className="space-y-4">
        <div className="rounded-lg border border-red-800 bg-red-900/20 p-4">
          <div className="flex items-center space-x-3">
            <Icon name="AlertTriangle" className="h-5 w-5 text-red-500" />
            <div>
              <h4 className="text-sm font-medium text-red-200">
                {itemName || "Item"}
              </h4>
              <p className="mt-1 text-xs text-red-300">{detailNote}</p>
            </div>
          </div>
        </div>
        <div className="flex space-x-3 pt-2">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="text-card-foreground bg-card border-border hover:bg-accent flex-1 rounded-lg border px-4 py-2 text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="flex-1 rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isLoading ? confirmLoadingText : defaultConfirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationModal;
